<script>
  import html2canvas from "html2canvas";
  import DownloadButton from "$components/Download/DownloadButton.svelte";
  import { logClickToGA } from "@urbaninstitute/dataviz-components";
  import { tick } from "svelte";

  /** @typedef {import("svelte").Snippet} Snippet */

  /**
   * @property {number} id id of the chart (used for export)
   * @property {string} filename
   * @property {Snippet} children
   * @property {string} label
   */
  let { id, filename, children, label } = $props();

  // setup export flag and ref
  let exportFlag = $state(false);

  /** @type {HTMLElement} */
  let exportRef;

  // handle export flag and download
  export const handleExport = () => {
    // set export flag to true to show export div
    exportFlag = true;

    return new Promise((resolve, reject) => {
      // wait for export div to render
      tick().then(() => {
        setTimeout(() => {
          // if export flag is true and export ref is available, export the chart
          // if (exportFlag && exportRef) {
          html2canvas(exportRef, {
            // filter out elements that should not be included in the image
            ignoreElements: (el) => el.classList.contains("button-container")
          }).then((canvas) => {
            try {
              const a = document.createElement("a");
              a.href = canvas.toDataURL("image/png").replace("image/jpeg", "image/octet-stream");
              a.download = `${filename}.png`;
              a.click();
              // turn off export flag when done
              exportFlag = false;
              resolve({ success: true });
            } catch {
              reject({ success: false });
            }
          });
          // }download
        }, 50);
      });
    });
  };
</script>

<DownloadButton
  {label}
  onclick={(e) => {
    handleExport(e);
    logClickToGA(e.target, "download-button-click");
  }}
/>
<!-- exported chart container -->
<div id={`exported-chart-${id}`} class="download-image-container" bind:this={exportRef}>
  {#if exportFlag}
    {@render children?.()}
  {/if}
</div>

<style>
  /* OFFSCREEN CHART POSITIONED ABSOLUTELY */
  .download-image-container {
    padding: var(--spacing-6) var(--spacing-12);
    position: absolute;
    left: -50000px;
    width: 800px;
  }
</style>
